module.exports = __webpack_public_path__ + "img/product-ai.796a784a.jpg";